import { useTranslation } from 'react-i18next';

const WA_NUMBER = '19862173604';
const PHONE = '+19862173604';
const PHONE_DISPLAY = '+1 (986) 217-3604';

const businessHoursData = [
  { dayKey: 'day_monday', hours: 'Closed' },
  { dayKey: 'day_tuesday', hours: '11:00 AM – 11:00 PM' },
  { dayKey: 'day_wednesday', hours: '11:00 AM – 11:00 PM' },
  { dayKey: 'day_thursday', hours: '11:00 AM – 11:00 PM' },
  { dayKey: 'day_friday', hours: '11:00 AM – 11:00 PM' },
  { dayKey: 'day_saturday', hours: '11:00 AM – 11:00 PM' },
  { dayKey: 'day_sunday', hours: '11:00 AM – 11:00 PM' },
];

const socialLinks = [
  {
    icon: 'ri-instagram-line',
    label: 'Instagram',
    handle: '@bucara__burger',
    href: 'https://instagram.com/bucara__burger',
    color: 'hover:text-pink-400',
  },
  {
    icon: 'ri-facebook-line',
    label: 'Facebook',
    handle: 'Bucara Burger',
    href: 'https://www.facebook.com/profile.php?id=61589000696717',
    color: 'hover:text-blue-400',
  },
  {
    icon: 'ri-tiktok-line',
    label: 'TikTok',
    handle: '@bucara__burger',
    href: 'https://tiktok.com/@bucara__burger',
    color: 'hover:text-white',
  },
];

const todayIndex = new Date().getDay(); // 0=Sun
const todayArrayIndex = todayIndex === 0 ? 6 : todayIndex - 1;

export default function ContactInfo() {
  const { t, i18n } = useTranslation();
  const waLink = i18n.language === 'es'
    ? 'https://wa.me/19862173604?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order.'
    : 'https://wa.me/19862173604?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order.';

  return (
    <div className="flex flex-col gap-6">
      {/* Address */}
      <div className="bg-[#111111] border border-white/5 rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 flex items-center justify-center bg-[#F57F25]/10 border border-[#F57F25]/20 rounded-lg shrink-0">
            <i className="ri-map-pin-line text-[#F57F25] text-lg"></i>
          </div>
          <h3 className="text-white font-bold text-sm uppercase tracking-widest">{t('location_address_title')}</h3>
        </div>
        <p className="text-white/80 text-base font-medium leading-relaxed mb-3">
          1630 Broadway Ave<br />
          Boise, Idaho 83706
        </p>
        <a
          href="https://maps.google.com/?q=1630+Broadway+Ave,+Boise,+Idaho+83706"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-[#F57F25] text-xs font-semibold hover:underline cursor-pointer"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-external-link-line text-xs"></i>
          </div>
          {t('btn_open_maps')}
        </a>
      </div>

      {/* Phone */}
      <div className="bg-[#111111] border border-white/5 rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 flex items-center justify-center bg-[#F57F25]/10 border border-[#F57F25]/20 rounded-lg shrink-0">
            <i className="ri-phone-line text-[#F57F25] text-lg"></i>
          </div>
          <h3 className="text-white font-bold text-sm uppercase tracking-widest">{t('location_phone_title')}</h3>
        </div>
        <a
          href={`tel:${PHONE}`}
          className="text-white/80 text-xl font-bold hover:text-[#F57F25] transition-colors cursor-pointer"
        >
          {PHONE_DISPLAY}
        </a>
        <p className="text-white/35 text-xs mt-1">{t('location_phone_tap')}</p>
      </div>

      {/* WhatsApp */}
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-4 bg-[#25D366]/10 border border-[#25D366]/25 hover:border-[#25D366]/50 rounded-2xl p-6 transition-all duration-200 cursor-pointer group"
      >
        <div className="w-12 h-12 flex items-center justify-center bg-[#25D366] rounded-xl shrink-0 group-hover:scale-105 transition-transform">
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </div>
        <div>
          <p className="text-white font-bold text-base">{t('location_wa_title')}</p>
          <p className="text-white/45 text-xs mt-0.5">{t('location_wa_sub')}</p>
        </div>
        <div className="ml-auto w-6 h-6 flex items-center justify-center text-white/30 group-hover:text-[#25D366] transition-colors">
          <i className="ri-arrow-right-line text-lg"></i>
        </div>
      </a>

      {/* Business Hours */}
      <div className="bg-[#111111] border border-white/5 rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-9 h-9 flex items-center justify-center bg-[#F57F25]/10 border border-[#F57F25]/20 rounded-lg shrink-0">
            <i className="ri-time-line text-[#F57F25] text-lg"></i>
          </div>
          <h3 className="text-white font-bold text-sm uppercase tracking-widest">{t('location_hours_title')}</h3>
        </div>
        <ul className="space-y-2.5">
          {businessHoursData.map(({ dayKey, hours }, idx) => {
            const isToday = idx === todayArrayIndex;
            const isClosed = hours === 'Closed';
            return (
              <li
                key={dayKey}
                className={`flex items-center justify-between text-sm rounded-lg px-3 py-2 transition-colors ${
                  isToday ? 'bg-[#F57F25]/10 border border-[#F57F25]/20' : ''
                }`}
              >
                <span className={`font-medium ${isToday ? 'text-[#F57F25]' : 'text-white/60'}`}>
                  {t(dayKey)}
                  {isToday && (
                    <span className="ml-2 text-[10px] bg-[#F57F25] text-black font-bold px-1.5 py-0.5 rounded-full uppercase">
                      {t('location_today')}
                    </span>
                  )}
                </span>
                <span className={`font-semibold ${isClosed ? 'text-white/25' : isToday ? 'text-white' : 'text-white/70'}`}>
                  {isClosed ? t('location_closed') : hours}
                </span>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Social Links */}
      <div className="bg-[#111111] border border-white/5 rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-9 h-9 flex items-center justify-center bg-[#F57F25]/10 border border-[#F57F25]/20 rounded-lg shrink-0">
            <i className="ri-share-line text-[#F57F25] text-lg"></i>
          </div>
          <h3 className="text-white font-bold text-sm uppercase tracking-widest">{t('location_social_title')}</h3>
        </div>
        <div className="flex flex-col gap-3">
          {socialLinks.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center gap-3 text-white/55 ${s.color} transition-colors cursor-pointer group`}
            >
              <div className="w-9 h-9 flex items-center justify-center bg-white/5 group-hover:bg-white/10 rounded-lg transition-colors">
                <i className={`${s.icon} text-lg`}></i>
              </div>
              <div>
                <p className="text-sm font-semibold">{s.label}</p>
                <p className="text-xs text-white/30">{s.handle}</p>
              </div>
              <div className="ml-auto w-4 h-4 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-external-link-line text-xs"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
